export default __webpack_public_path__ + "static/media/arrow-down.56862810.svg";